import { useQuery } from '@tanstack/react-query';
import productChangeHistoryService from 'v2/services/ProductChangeHistory';

import type { UseQueryOptions } from '@tanstack/react-query';
import type { ChangeLogHistory } from 'scenes/Producer/Product/MyProducts/components/QuickView/components/ProductChangeHistory/ChangeHistoryContent/ChangeHistoryDetails/constants';

type Payload = {
  productId: number;
  historyId: number;
};

export function useProductChangeHistoryDetails({ productId, historyId }: Payload, options: UseQueryOptions<ChangeLogHistory[]> = {}) {
  return useQuery({
    queryKey: ['product', productId, 'changeHistory', historyId],
    queryFn: () => productChangeHistoryService.getChangeHistoryDetails(productId, historyId),
    ...options,
  });
}
